export default "__VITE_ASSET__BAPJjySU__"